import { render, staticRenderFns } from "./GoogleTaskAdsWidget.vue?vue&type=template&id=47db9ebf&scoped=true&"
import script from "./GoogleTaskAdsWidget.vue?vue&type=script&lang=js&"
export * from "./GoogleTaskAdsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db9ebf",
  null
  
)

export default component.exports